import { clsx } from 'clsx'

import { Post, PostStatus } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { MemberAvatar } from '../common/components/index.js'
import { T } from '../i18n/components/T.js'
import { MemberBadgeLocation } from '../MemberBadge/MemberBadge.js'
import { MemberBadges } from '../MemberBadge/MemberBadges.js'

import { PostMemberBarInfo } from './PostMemberBarInfo.js'

export const PostMemberBar = ({
  post,
  showSpace = true,
}: {
  showSpace?: boolean
  post: Partial<Post>
}) => {
  const { Link } = useRouter()
  const member = post?.owner?.member

  return (
    <div
      className={clsx(
        'flex items-center space-s-4 min-w-0 grow post-member-bar',
        !member && 'animate-pulse',
      )}
    >
      <div className="shrink-0">
        <MemberAvatar member={member} size="3x" clickable />
      </div>
      <div className="min-w-0 grow">
        <div className="flex items-center flex-wrap gap-x-2 gap-y-0.5 text-content max-w-full">
          <Link
            href={member?.relativeUrl}
            variant="inherit"
            className="font-medium truncate block focus-visible:z-10"
            translate="no"
            title={member?.name}
          >
            {member?.name ? (
              <>{member?.name}</>
            ) : (
              <div className="h-4 w-32 bg-surface-pressed rounded-full"></div>
            )}
          </Link>
          <MemberBadges
            member={member}
            size="sm"
            location={MemberBadgeLocation.PostMemberBar}
          />
        </div>
        <div className="text-sm text-content-subdued mt-0.5 flex max-w-full">
          {post?.status === PostStatus.DELETED && (
            <span>
              <span className="text-action-destructive inline-flex items-center">
                <span>
                  <T defaultMessage="Deleted" id="Generics.Deleted" />
                </span>
                <SvgIcon className="w-4 h-4 ms-0.5" name="trash" />
              </span>
              {/* eslint-disable-next-line react/jsx-no-literals */}
              <span>&nbsp;·&nbsp;</span>
            </span>
          )}
          <PostMemberBarInfo
            post={post}
            showSpace={showSpace}
            memberName={member?.name}
            memberTagline={member?.tagline}
          />
        </div>
      </div>
    </div>
  )
}
